import { useEffect, useState } from "react";
import styles from "./MemberActivityTable.module.css";
import { SORTING_OPTIONS } from "../../../../../constant";
import DataTableWithFilters from "../../../../CommonComponents/DataTableWithFilters";
import ActionMenu from "../../../../CommonComponents/ActionMenu";
import { ENTERPRISE_COMPANY } from "../../../../../urlConfig";
import { formatNumbers } from "../../../../../utils/NumberFormat";
import { useNavigate } from "react-router-dom";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import useNotification from "../../../../../hooks/useNotification";
import userAvatar from "../../../../../assets/userAvatar-Other.png";
import moment from "moment";

const AllData = [
  {
    key: "1",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "2",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "3",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "4",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "5",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "6",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "7",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "8",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "9",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
  {
    key: "10",
    activity: "Moved Candidate to offer",
    section: "Job",
    date: "2024-10-19T14:33:28Z",
    time: "2024-10-19T14:33:28Z",
  },
];

const MemberActivityTable = () => {
  const navigate = useNavigate();
  const [selectedSort, setSelectedSort] = useState(["Most Recent"]);
  const [searchInput, setSearchInput] = useState("");
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState();
  const [prevPage, setPrevPage] = useState();
  const [total, setTotal] = useState(100);

  const fetchUserOverviewData = async (nextPage, prevPage) => {
    setLoading(true);

    let queryParams = [`pageSize=10`];

    if (nextPage) queryParams.push(`nextPage=${nextPage}`);
    if (prevPage) queryParams.push(`prevPage=${prevPage}`);
    if (searchInput) queryParams.push(`search=${searchInput}`);

    let str = queryParams.join("&");

    const res = await EnterpriseServices.getEnterpriseList(str);

    if (res) {
      if (res.statusCode === 1) {
        setData(AllData);
        setTotal(res.total);
        setNextPage(res.nextPage);
        setPrevPage(res.prevPage);
      } else {
        handleError(`${res.statusDesc}`);
      }
    } else {
      handleError(`Error: ${res.statusDesc}`);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUserOverviewData();
  }, []);

  const handleDelete = (id) => {
    console.warn("delete clicked", id);
  };

  const handleClick = (record) => {
    navigate(ENTERPRISE_COMPANY + record.key);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const handleSearch = (value) => {
    setSearchInput(value);
  };

  const handlePageChange = (isNextPage) => {
    if (isNextPage) {
      fetchUserOverviewData(nextPage, "", false);
    } else {
      fetchUserOverviewData("", prevPage, true);
    }
  };

  useEffect(() => {
    fetchUserOverviewData();
  }, [searchInput]);

  const columns = [
    {
      title: `Activity`,
      dataIndex: "activity",
      key: "activity",
      minWidth: 200,
      render: (activity, record) => {
        return (
          <div
            className={styles.user_image_wrap}
            onClick={() => handleClick(record)}
          >
            {activity}
          </div>
        );
      },
    },
    {
      title: "Section",
      dataIndex: "section",
      key: "section",
      render: (section, record) => {
        return <div className={styles.tag_cell}>{section}</div>;
      },
    },

    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      minWidth: 130,
      render: (date, record) => {
        return <div>{moment(new Date(date)).format("ll")}</div>; // just for decoration
      },
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      minWidth: 130,
      render: (time, record) => {
        return <div>{moment(new Date(time)).format("LT")}</div>; // just for decoration
      },
    },
    {
      title: "",
      dataIndex: "Actions",
      key: "Actions",
      minWidth: 10,
      maxWidth: 15,
      render: (status, record) => {
        return (
          <div>
            <ActionMenu
              options={[
                {
                  label: "Edit",
                  route: ENTERPRISE_COMPANY + record.key,
                },
                // {
                //   label: "Delete",
                //   action: () => handleDelete(record),
                // },
              ]}
            />
          </div>
        );
      },
    },
  ];

  const handleSortChange = (value) => {
    setSelectedSort(value);
  };

  const handleFilterChange = (value) => {};

  return (
    <div className={styles.content_wrap}>
      <DataTableWithFilters
        columns={columns}
        data={data}
        sortOptions={SORTING_OPTIONS}
        handleFilterChange={handleFilterChange}
        handleSortChange={handleSortChange}
        selectedSort={selectedSort}
        tableKey={"key"}
        pageSize={10}
        loading={loading}
        total={total}
        hideSearch={true}
        handlePageChange={handlePageChange}
        scroll={{
          x: "max-content",
        }}
      />
    </div>
  );
};

export default MemberActivityTable;
